// Protocol Buffers for Admin Dashboard Services
// 
// Package: guardianai.v1.admin

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file guardianai/v1/admin/admin.proto (package guardianai.v1.admin, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file guardianai/v1/admin/admin.proto.
 */
export const file_guardianai_v1_admin_admin: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message guardianai.v1.admin.AdminDashboardRequest
 */
export type AdminDashboardRequest = Message<"guardianai.v1.admin.AdminDashboardRequest"> & {
  /**
   * @generated from field: string admin_id = 1;
   */
  adminId: string;

  /**
   * "day", "week", "month"
   *
   * @generated from field: string period = 2;
   */
  period: string;
};

/**
 * @generated from message guardianai.v1.admin.AdminDashboardRequest
 */
export type AdminDashboardRequestJson = {
  /**
   * @generated from field: string admin_id = 1;
   */
  adminId?: string;

  /**
   * "day", "week", "month"
   *
   * @generated from field: string period = 2;
   */
  period?: string;
};

/**
 * Describes the message guardianai.v1.admin.AdminDashboardRequest.
 * Use `create(AdminDashboardRequestSchema)` to create a new message.
 */
export const AdminDashboardRequestSchema: GenMessage<AdminDashboardRequest, {jsonType: AdminDashboardRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 0);

/**
 * @generated from message guardianai.v1.admin.AdminDashboardResponse
 */
export type AdminDashboardResponse = Message<"guardianai.v1.admin.AdminDashboardResponse"> & {
  /**
   * @generated from field: guardianai.v1.admin.PlatformStats stats = 1;
   */
  stats?: PlatformStats;

  /**
   * @generated from field: repeated guardianai.v1.admin.UserSummary recent_users = 2;
   */
  recentUsers: UserSummary[];

  /**
   * @generated from field: repeated guardianai.v1.admin.FraudSummary recent_fraud = 3;
   */
  recentFraud: FraudSummary[];

  /**
   * @generated from field: guardianai.v1.admin.SystemHealth system_health = 4;
   */
  systemHealth?: SystemHealth;
};

/**
 * @generated from message guardianai.v1.admin.AdminDashboardResponse
 */
export type AdminDashboardResponseJson = {
  /**
   * @generated from field: guardianai.v1.admin.PlatformStats stats = 1;
   */
  stats?: PlatformStatsJson;

  /**
   * @generated from field: repeated guardianai.v1.admin.UserSummary recent_users = 2;
   */
  recentUsers?: UserSummaryJson[];

  /**
   * @generated from field: repeated guardianai.v1.admin.FraudSummary recent_fraud = 3;
   */
  recentFraud?: FraudSummaryJson[];

  /**
   * @generated from field: guardianai.v1.admin.SystemHealth system_health = 4;
   */
  systemHealth?: SystemHealthJson;
};

/**
 * Describes the message guardianai.v1.admin.AdminDashboardResponse.
 * Use `create(AdminDashboardResponseSchema)` to create a new message.
 */
export const AdminDashboardResponseSchema: GenMessage<AdminDashboardResponse, {jsonType: AdminDashboardResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 1);

/**
 * @generated from message guardianai.v1.admin.PlatformStats
 */
export type PlatformStats = Message<"guardianai.v1.admin.PlatformStats"> & {
  /**
   * @generated from field: int64 total_users = 1;
   */
  totalUsers: bigint;

  /**
   * @generated from field: int64 active_users = 2;
   */
  activeUsers: bigint;

  /**
   * @generated from field: int64 total_scans = 3;
   */
  totalScans: bigint;

  /**
   * @generated from field: int64 fraud_detected = 4;
   */
  fraudDetected: bigint;

  /**
   * @generated from field: double fraud_detection_rate = 5;
   */
  fraudDetectionRate: number;

  /**
   * @generated from field: double avg_trust_score = 6;
   */
  avgTrustScore: number;

  /**
   * @generated from field: int64 total_revenue = 7;
   */
  totalRevenue: bigint;

  /**
   * @generated from field: int64 pending_reviews = 8;
   */
  pendingReviews: bigint;
};

/**
 * @generated from message guardianai.v1.admin.PlatformStats
 */
export type PlatformStatsJson = {
  /**
   * @generated from field: int64 total_users = 1;
   */
  totalUsers?: string;

  /**
   * @generated from field: int64 active_users = 2;
   */
  activeUsers?: string;

  /**
   * @generated from field: int64 total_scans = 3;
   */
  totalScans?: string;

  /**
   * @generated from field: int64 fraud_detected = 4;
   */
  fraudDetected?: string;

  /**
   * @generated from field: double fraud_detection_rate = 5;
   */
  fraudDetectionRate?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double avg_trust_score = 6;
   */
  avgTrustScore?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: int64 total_revenue = 7;
   */
  totalRevenue?: string;

  /**
   * @generated from field: int64 pending_reviews = 8;
   */
  pendingReviews?: string;
};

/**
 * Describes the message guardianai.v1.admin.PlatformStats.
 * Use `create(PlatformStatsSchema)` to create a new message.
 */
export const PlatformStatsSchema: GenMessage<PlatformStats, {jsonType: PlatformStatsJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 2);

/**
 * @generated from message guardianai.v1.admin.UserSummary
 */
export type UserSummary = Message<"guardianai.v1.admin.UserSummary"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string email = 2;
   */
  email: string;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName: string;

  /**
   * @generated from field: string role = 4;
   */
  role: string;

  /**
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * @generated from field: int64 created_at = 6;
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 last_active = 7;
   */
  lastActive: bigint;
};

/**
 * @generated from message guardianai.v1.admin.UserSummary
 */
export type UserSummaryJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string email = 2;
   */
  email?: string;

  /**
   * @generated from field: string display_name = 3;
   */
  displayName?: string;

  /**
   * @generated from field: string role = 4;
   */
  role?: string;

  /**
   * @generated from field: string status = 5;
   */
  status?: string;

  /**
   * @generated from field: int64 created_at = 6;
   */
  createdAt?: string;

  /**
   * @generated from field: int64 last_active = 7;
   */
  lastActive?: string;
};

/**
 * Describes the message guardianai.v1.admin.UserSummary.
 * Use `create(UserSummarySchema)` to create a new message.
 */
export const UserSummarySchema: GenMessage<UserSummary, {jsonType: UserSummaryJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 3);

/**
 * @generated from message guardianai.v1.admin.FraudSummary
 */
export type FraudSummary = Message<"guardianai.v1.admin.FraudSummary"> & {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId: string;

  /**
   * @generated from field: string reporter_id = 2;
   */
  reporterId: string;

  /**
   * @generated from field: string subject_email = 3;
   */
  subjectEmail: string;

  /**
   * @generated from field: string fraud_type = 4;
   */
  fraudType: string;

  /**
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * @generated from field: int64 created_at = 6;
   */
  createdAt: bigint;
};

/**
 * @generated from message guardianai.v1.admin.FraudSummary
 */
export type FraudSummaryJson = {
  /**
   * @generated from field: string report_id = 1;
   */
  reportId?: string;

  /**
   * @generated from field: string reporter_id = 2;
   */
  reporterId?: string;

  /**
   * @generated from field: string subject_email = 3;
   */
  subjectEmail?: string;

  /**
   * @generated from field: string fraud_type = 4;
   */
  fraudType?: string;

  /**
   * @generated from field: string status = 5;
   */
  status?: string;

  /**
   * @generated from field: int64 created_at = 6;
   */
  createdAt?: string;
};

/**
 * Describes the message guardianai.v1.admin.FraudSummary.
 * Use `create(FraudSummarySchema)` to create a new message.
 */
export const FraudSummarySchema: GenMessage<FraudSummary, {jsonType: FraudSummaryJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 4);

/**
 * @generated from message guardianai.v1.admin.SystemHealth
 */
export type SystemHealth = Message<"guardianai.v1.admin.SystemHealth"> & {
  /**
   * "healthy", "degraded", "down"
   *
   * @generated from field: string status = 1;
   */
  status: string;

  /**
   * @generated from field: double cpu_usage = 2;
   */
  cpuUsage: number;

  /**
   * @generated from field: double memory_usage = 3;
   */
  memoryUsage: number;

  /**
   * @generated from field: int64 active_connections = 4;
   */
  activeConnections: bigint;

  /**
   * @generated from field: repeated guardianai.v1.admin.ServiceStatus services = 5;
   */
  services: ServiceStatus[];
};

/**
 * @generated from message guardianai.v1.admin.SystemHealth
 */
export type SystemHealthJson = {
  /**
   * "healthy", "degraded", "down"
   *
   * @generated from field: string status = 1;
   */
  status?: string;

  /**
   * @generated from field: double cpu_usage = 2;
   */
  cpuUsage?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: double memory_usage = 3;
   */
  memoryUsage?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: int64 active_connections = 4;
   */
  activeConnections?: string;

  /**
   * @generated from field: repeated guardianai.v1.admin.ServiceStatus services = 5;
   */
  services?: ServiceStatusJson[];
};

/**
 * Describes the message guardianai.v1.admin.SystemHealth.
 * Use `create(SystemHealthSchema)` to create a new message.
 */
export const SystemHealthSchema: GenMessage<SystemHealth, {jsonType: SystemHealthJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 5);

/**
 * @generated from message guardianai.v1.admin.ServiceStatus
 */
export type ServiceStatus = Message<"guardianai.v1.admin.ServiceStatus"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * @generated from field: int64 latency_ms = 3;
   */
  latencyMs: bigint;
};

/**
 * @generated from message guardianai.v1.admin.ServiceStatus
 */
export type ServiceStatusJson = {
  /**
   * @generated from field: string name = 1;
   */
  name?: string;

  /**
   * @generated from field: string status = 2;
   */
  status?: string;

  /**
   * @generated from field: int64 latency_ms = 3;
   */
  latencyMs?: string;
};

/**
 * Describes the message guardianai.v1.admin.ServiceStatus.
 * Use `create(ServiceStatusSchema)` to create a new message.
 */
export const ServiceStatusSchema: GenMessage<ServiceStatus, {jsonType: ServiceStatusJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 6);

/**
 * @generated from message guardianai.v1.admin.SystemHealthRequest
 */
export type SystemHealthRequest = Message<"guardianai.v1.admin.SystemHealthRequest"> & {
};

/**
 * @generated from message guardianai.v1.admin.SystemHealthRequest
 */
export type SystemHealthRequestJson = {
};

/**
 * Describes the message guardianai.v1.admin.SystemHealthRequest.
 * Use `create(SystemHealthRequestSchema)` to create a new message.
 */
export const SystemHealthRequestSchema: GenMessage<SystemHealthRequest, {jsonType: SystemHealthRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 7);

/**
 * @generated from message guardianai.v1.admin.SystemHealthResponse
 */
export type SystemHealthResponse = Message<"guardianai.v1.admin.SystemHealthResponse"> & {
  /**
   * @generated from field: guardianai.v1.admin.SystemHealth health = 1;
   */
  health?: SystemHealth;
};

/**
 * @generated from message guardianai.v1.admin.SystemHealthResponse
 */
export type SystemHealthResponseJson = {
  /**
   * @generated from field: guardianai.v1.admin.SystemHealth health = 1;
   */
  health?: SystemHealthJson;
};

/**
 * Describes the message guardianai.v1.admin.SystemHealthResponse.
 * Use `create(SystemHealthResponseSchema)` to create a new message.
 */
export const SystemHealthResponseSchema: GenMessage<SystemHealthResponse, {jsonType: SystemHealthResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 8);

/**
 * @generated from message guardianai.v1.admin.PlatformStatsRequest
 */
export type PlatformStatsRequest = Message<"guardianai.v1.admin.PlatformStatsRequest"> & {
  /**
   * @generated from field: string period = 1;
   */
  period: string;
};

/**
 * @generated from message guardianai.v1.admin.PlatformStatsRequest
 */
export type PlatformStatsRequestJson = {
  /**
   * @generated from field: string period = 1;
   */
  period?: string;
};

/**
 * Describes the message guardianai.v1.admin.PlatformStatsRequest.
 * Use `create(PlatformStatsRequestSchema)` to create a new message.
 */
export const PlatformStatsRequestSchema: GenMessage<PlatformStatsRequest, {jsonType: PlatformStatsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 9);

/**
 * @generated from message guardianai.v1.admin.PlatformStatsResponse
 */
export type PlatformStatsResponse = Message<"guardianai.v1.admin.PlatformStatsResponse"> & {
  /**
   * @generated from field: guardianai.v1.admin.PlatformStats stats = 1;
   */
  stats?: PlatformStats;
};

/**
 * @generated from message guardianai.v1.admin.PlatformStatsResponse
 */
export type PlatformStatsResponseJson = {
  /**
   * @generated from field: guardianai.v1.admin.PlatformStats stats = 1;
   */
  stats?: PlatformStatsJson;
};

/**
 * Describes the message guardianai.v1.admin.PlatformStatsResponse.
 * Use `create(PlatformStatsResponseSchema)` to create a new message.
 */
export const PlatformStatsResponseSchema: GenMessage<PlatformStatsResponse, {jsonType: PlatformStatsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 10);

/**
 * User management messages
 *
 * @generated from message guardianai.v1.admin.ListUsersRequest
 */
export type ListUsersRequest = Message<"guardianai.v1.admin.ListUsersRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string role_filter = 3;
   */
  roleFilter: string;

  /**
   * @generated from field: string status_filter = 4;
   */
  statusFilter: string;

  /**
   * @generated from field: string search_query = 5;
   */
  searchQuery: string;
};

/**
 * User management messages
 *
 * @generated from message guardianai.v1.admin.ListUsersRequest
 */
export type ListUsersRequestJson = {
  /**
   * @generated from field: int32 page = 1;
   */
  page?: number;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize?: number;

  /**
   * @generated from field: string role_filter = 3;
   */
  roleFilter?: string;

  /**
   * @generated from field: string status_filter = 4;
   */
  statusFilter?: string;

  /**
   * @generated from field: string search_query = 5;
   */
  searchQuery?: string;
};

/**
 * Describes the message guardianai.v1.admin.ListUsersRequest.
 * Use `create(ListUsersRequestSchema)` to create a new message.
 */
export const ListUsersRequestSchema: GenMessage<ListUsersRequest, {jsonType: ListUsersRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 11);

/**
 * @generated from message guardianai.v1.admin.ListUsersResponse
 */
export type ListUsersResponse = Message<"guardianai.v1.admin.ListUsersResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.admin.UserSummary users = 1;
   */
  users: UserSummary[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * @generated from field: int32 page = 3;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 4;
   */
  pageSize: number;
};

/**
 * @generated from message guardianai.v1.admin.ListUsersResponse
 */
export type ListUsersResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.admin.UserSummary users = 1;
   */
  users?: UserSummaryJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;

  /**
   * @generated from field: int32 page = 3;
   */
  page?: number;

  /**
   * @generated from field: int32 page_size = 4;
   */
  pageSize?: number;
};

/**
 * Describes the message guardianai.v1.admin.ListUsersResponse.
 * Use `create(ListUsersResponseSchema)` to create a new message.
 */
export const ListUsersResponseSchema: GenMessage<ListUsersResponse, {jsonType: ListUsersResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 12);

/**
 * @generated from message guardianai.v1.admin.GetUserDetailsRequest
 */
export type GetUserDetailsRequest = Message<"guardianai.v1.admin.GetUserDetailsRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;
};

/**
 * @generated from message guardianai.v1.admin.GetUserDetailsRequest
 */
export type GetUserDetailsRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;
};

/**
 * Describes the message guardianai.v1.admin.GetUserDetailsRequest.
 * Use `create(GetUserDetailsRequestSchema)` to create a new message.
 */
export const GetUserDetailsRequestSchema: GenMessage<GetUserDetailsRequest, {jsonType: GetUserDetailsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 13);

/**
 * @generated from message guardianai.v1.admin.UserDetailsResponse
 */
export type UserDetailsResponse = Message<"guardianai.v1.admin.UserDetailsResponse"> & {
  /**
   * @generated from field: guardianai.v1.admin.UserSummary user = 1;
   */
  user?: UserSummary;

  /**
   * @generated from field: repeated string permissions = 2;
   */
  permissions: string[];

  /**
   * @generated from field: repeated guardianai.v1.admin.ActivityRecord recent_activity = 3;
   */
  recentActivity: ActivityRecord[];
};

/**
 * @generated from message guardianai.v1.admin.UserDetailsResponse
 */
export type UserDetailsResponseJson = {
  /**
   * @generated from field: guardianai.v1.admin.UserSummary user = 1;
   */
  user?: UserSummaryJson;

  /**
   * @generated from field: repeated string permissions = 2;
   */
  permissions?: string[];

  /**
   * @generated from field: repeated guardianai.v1.admin.ActivityRecord recent_activity = 3;
   */
  recentActivity?: ActivityRecordJson[];
};

/**
 * Describes the message guardianai.v1.admin.UserDetailsResponse.
 * Use `create(UserDetailsResponseSchema)` to create a new message.
 */
export const UserDetailsResponseSchema: GenMessage<UserDetailsResponse, {jsonType: UserDetailsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 14);

/**
 * @generated from message guardianai.v1.admin.ActivityRecord
 */
export type ActivityRecord = Message<"guardianai.v1.admin.ActivityRecord"> & {
  /**
   * @generated from field: string action = 1;
   */
  action: string;

  /**
   * @generated from field: string resource = 2;
   */
  resource: string;

  /**
   * @generated from field: int64 timestamp = 3;
   */
  timestamp: bigint;
};

/**
 * @generated from message guardianai.v1.admin.ActivityRecord
 */
export type ActivityRecordJson = {
  /**
   * @generated from field: string action = 1;
   */
  action?: string;

  /**
   * @generated from field: string resource = 2;
   */
  resource?: string;

  /**
   * @generated from field: int64 timestamp = 3;
   */
  timestamp?: string;
};

/**
 * Describes the message guardianai.v1.admin.ActivityRecord.
 * Use `create(ActivityRecordSchema)` to create a new message.
 */
export const ActivityRecordSchema: GenMessage<ActivityRecord, {jsonType: ActivityRecordJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 15);

/**
 * @generated from message guardianai.v1.admin.SuspendUserRequest
 */
export type SuspendUserRequest = Message<"guardianai.v1.admin.SuspendUserRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * @generated from field: string suspended_by = 3;
   */
  suspendedBy: string;
};

/**
 * @generated from message guardianai.v1.admin.SuspendUserRequest
 */
export type SuspendUserRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason?: string;

  /**
   * @generated from field: string suspended_by = 3;
   */
  suspendedBy?: string;
};

/**
 * Describes the message guardianai.v1.admin.SuspendUserRequest.
 * Use `create(SuspendUserRequestSchema)` to create a new message.
 */
export const SuspendUserRequestSchema: GenMessage<SuspendUserRequest, {jsonType: SuspendUserRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 16);

/**
 * @generated from message guardianai.v1.admin.SuspendUserResponse
 */
export type SuspendUserResponse = Message<"guardianai.v1.admin.SuspendUserResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.admin.SuspendUserResponse
 */
export type SuspendUserResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.admin.SuspendUserResponse.
 * Use `create(SuspendUserResponseSchema)` to create a new message.
 */
export const SuspendUserResponseSchema: GenMessage<SuspendUserResponse, {jsonType: SuspendUserResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 17);

/**
 * @generated from message guardianai.v1.admin.RestoreUserRequest
 */
export type RestoreUserRequest = Message<"guardianai.v1.admin.RestoreUserRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string restored_by = 2;
   */
  restoredBy: string;
};

/**
 * @generated from message guardianai.v1.admin.RestoreUserRequest
 */
export type RestoreUserRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string restored_by = 2;
   */
  restoredBy?: string;
};

/**
 * Describes the message guardianai.v1.admin.RestoreUserRequest.
 * Use `create(RestoreUserRequestSchema)` to create a new message.
 */
export const RestoreUserRequestSchema: GenMessage<RestoreUserRequest, {jsonType: RestoreUserRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 18);

/**
 * @generated from message guardianai.v1.admin.RestoreUserResponse
 */
export type RestoreUserResponse = Message<"guardianai.v1.admin.RestoreUserResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.admin.RestoreUserResponse
 */
export type RestoreUserResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.admin.RestoreUserResponse.
 * Use `create(RestoreUserResponseSchema)` to create a new message.
 */
export const RestoreUserResponseSchema: GenMessage<RestoreUserResponse, {jsonType: RestoreUserResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 19);

/**
 * @generated from message guardianai.v1.admin.UpdateUserRoleRequest
 */
export type UpdateUserRoleRequest = Message<"guardianai.v1.admin.UpdateUserRoleRequest"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string new_role = 2;
   */
  newRole: string;

  /**
   * @generated from field: string updated_by = 3;
   */
  updatedBy: string;
};

/**
 * @generated from message guardianai.v1.admin.UpdateUserRoleRequest
 */
export type UpdateUserRoleRequestJson = {
  /**
   * @generated from field: string user_id = 1;
   */
  userId?: string;

  /**
   * @generated from field: string new_role = 2;
   */
  newRole?: string;

  /**
   * @generated from field: string updated_by = 3;
   */
  updatedBy?: string;
};

/**
 * Describes the message guardianai.v1.admin.UpdateUserRoleRequest.
 * Use `create(UpdateUserRoleRequestSchema)` to create a new message.
 */
export const UpdateUserRoleRequestSchema: GenMessage<UpdateUserRoleRequest, {jsonType: UpdateUserRoleRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 20);

/**
 * @generated from message guardianai.v1.admin.UpdateUserRoleResponse
 */
export type UpdateUserRoleResponse = Message<"guardianai.v1.admin.UpdateUserRoleResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.admin.UpdateUserRoleResponse
 */
export type UpdateUserRoleResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.admin.UpdateUserRoleResponse.
 * Use `create(UpdateUserRoleResponseSchema)` to create a new message.
 */
export const UpdateUserRoleResponseSchema: GenMessage<UpdateUserRoleResponse, {jsonType: UpdateUserRoleResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 21);

/**
 * Content moderation messages
 *
 * @generated from message guardianai.v1.admin.ReviewContentRequest
 */
export type ReviewContentRequest = Message<"guardianai.v1.admin.ReviewContentRequest"> & {
  /**
   * @generated from field: string content_id = 1;
   */
  contentId: string;

  /**
   * @generated from field: string content_type = 2;
   */
  contentType: string;
};

/**
 * Content moderation messages
 *
 * @generated from message guardianai.v1.admin.ReviewContentRequest
 */
export type ReviewContentRequestJson = {
  /**
   * @generated from field: string content_id = 1;
   */
  contentId?: string;

  /**
   * @generated from field: string content_type = 2;
   */
  contentType?: string;
};

/**
 * Describes the message guardianai.v1.admin.ReviewContentRequest.
 * Use `create(ReviewContentRequestSchema)` to create a new message.
 */
export const ReviewContentRequestSchema: GenMessage<ReviewContentRequest, {jsonType: ReviewContentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 22);

/**
 * @generated from message guardianai.v1.admin.ReviewContentResponse
 */
export type ReviewContentResponse = Message<"guardianai.v1.admin.ReviewContentResponse"> & {
  /**
   * @generated from field: string content_id = 1;
   */
  contentId: string;

  /**
   * @generated from field: string content_type = 2;
   */
  contentType: string;

  /**
   * @generated from field: string content_data = 3;
   */
  contentData: string;

  /**
   * @generated from field: string current_status = 4;
   */
  currentStatus: string;

  /**
   * @generated from field: repeated string flags = 5;
   */
  flags: string[];
};

/**
 * @generated from message guardianai.v1.admin.ReviewContentResponse
 */
export type ReviewContentResponseJson = {
  /**
   * @generated from field: string content_id = 1;
   */
  contentId?: string;

  /**
   * @generated from field: string content_type = 2;
   */
  contentType?: string;

  /**
   * @generated from field: string content_data = 3;
   */
  contentData?: string;

  /**
   * @generated from field: string current_status = 4;
   */
  currentStatus?: string;

  /**
   * @generated from field: repeated string flags = 5;
   */
  flags?: string[];
};

/**
 * Describes the message guardianai.v1.admin.ReviewContentResponse.
 * Use `create(ReviewContentResponseSchema)` to create a new message.
 */
export const ReviewContentResponseSchema: GenMessage<ReviewContentResponse, {jsonType: ReviewContentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 23);

/**
 * @generated from message guardianai.v1.admin.ApproveContentRequest
 */
export type ApproveContentRequest = Message<"guardianai.v1.admin.ApproveContentRequest"> & {
  /**
   * @generated from field: string content_id = 1;
   */
  contentId: string;

  /**
   * @generated from field: string approved_by = 2;
   */
  approvedBy: string;

  /**
   * @generated from field: string notes = 3;
   */
  notes: string;
};

/**
 * @generated from message guardianai.v1.admin.ApproveContentRequest
 */
export type ApproveContentRequestJson = {
  /**
   * @generated from field: string content_id = 1;
   */
  contentId?: string;

  /**
   * @generated from field: string approved_by = 2;
   */
  approvedBy?: string;

  /**
   * @generated from field: string notes = 3;
   */
  notes?: string;
};

/**
 * Describes the message guardianai.v1.admin.ApproveContentRequest.
 * Use `create(ApproveContentRequestSchema)` to create a new message.
 */
export const ApproveContentRequestSchema: GenMessage<ApproveContentRequest, {jsonType: ApproveContentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 24);

/**
 * @generated from message guardianai.v1.admin.ApproveContentResponse
 */
export type ApproveContentResponse = Message<"guardianai.v1.admin.ApproveContentResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.admin.ApproveContentResponse
 */
export type ApproveContentResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.admin.ApproveContentResponse.
 * Use `create(ApproveContentResponseSchema)` to create a new message.
 */
export const ApproveContentResponseSchema: GenMessage<ApproveContentResponse, {jsonType: ApproveContentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 25);

/**
 * @generated from message guardianai.v1.admin.RejectContentRequest
 */
export type RejectContentRequest = Message<"guardianai.v1.admin.RejectContentRequest"> & {
  /**
   * @generated from field: string content_id = 1;
   */
  contentId: string;

  /**
   * @generated from field: string rejected_by = 2;
   */
  rejectedBy: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * @generated from message guardianai.v1.admin.RejectContentRequest
 */
export type RejectContentRequestJson = {
  /**
   * @generated from field: string content_id = 1;
   */
  contentId?: string;

  /**
   * @generated from field: string rejected_by = 2;
   */
  rejectedBy?: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason?: string;
};

/**
 * Describes the message guardianai.v1.admin.RejectContentRequest.
 * Use `create(RejectContentRequestSchema)` to create a new message.
 */
export const RejectContentRequestSchema: GenMessage<RejectContentRequest, {jsonType: RejectContentRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 26);

/**
 * @generated from message guardianai.v1.admin.RejectContentResponse
 */
export type RejectContentResponse = Message<"guardianai.v1.admin.RejectContentResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * @generated from message guardianai.v1.admin.RejectContentResponse
 */
export type RejectContentResponseJson = {
  /**
   * @generated from field: bool success = 1;
   */
  success?: boolean;

  /**
   * @generated from field: string message = 2;
   */
  message?: string;
};

/**
 * Describes the message guardianai.v1.admin.RejectContentResponse.
 * Use `create(RejectContentResponseSchema)` to create a new message.
 */
export const RejectContentResponseSchema: GenMessage<RejectContentResponse, {jsonType: RejectContentResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 27);

/**
 * @generated from message guardianai.v1.admin.WorkItemResponse
 */
export type WorkItemResponse = Message<"guardianai.v1.admin.WorkItemResponse"> & {
  /**
   * @generated from field: string work_item_id = 1;
   */
  workItemId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string type = 4;
   */
  type: string;

  /**
   * @generated from field: string status = 5;
   */
  status: string;

  /**
   * @generated from field: string priority = 6;
   */
  priority: string;

  /**
   * @generated from field: string assignee_id = 7;
   */
  assigneeId: string;

  /**
   * @generated from field: string created_by = 8;
   */
  createdBy: string;

  /**
   * @generated from field: int64 created_at = 9;
   */
  createdAt: bigint;

  /**
   * @generated from field: int64 updated_at = 10;
   */
  updatedAt: bigint;

  /**
   * @generated from field: int64 due_date = 11;
   */
  dueDate: bigint;

  /**
   * @generated from field: map<string, string> metadata = 12;
   */
  metadata: { [key: string]: string };
};

/**
 * @generated from message guardianai.v1.admin.WorkItemResponse
 */
export type WorkItemResponseJson = {
  /**
   * @generated from field: string work_item_id = 1;
   */
  workItemId?: string;

  /**
   * @generated from field: string title = 2;
   */
  title?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: string type = 4;
   */
  type?: string;

  /**
   * @generated from field: string status = 5;
   */
  status?: string;

  /**
   * @generated from field: string priority = 6;
   */
  priority?: string;

  /**
   * @generated from field: string assignee_id = 7;
   */
  assigneeId?: string;

  /**
   * @generated from field: string created_by = 8;
   */
  createdBy?: string;

  /**
   * @generated from field: int64 created_at = 9;
   */
  createdAt?: string;

  /**
   * @generated from field: int64 updated_at = 10;
   */
  updatedAt?: string;

  /**
   * @generated from field: int64 due_date = 11;
   */
  dueDate?: string;

  /**
   * @generated from field: map<string, string> metadata = 12;
   */
  metadata?: { [key: string]: string };
};

/**
 * Describes the message guardianai.v1.admin.WorkItemResponse.
 * Use `create(WorkItemResponseSchema)` to create a new message.
 */
export const WorkItemResponseSchema: GenMessage<WorkItemResponse, {jsonType: WorkItemResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 28);

/**
 * @generated from message guardianai.v1.admin.CreateWorkItemRequest
 */
export type CreateWorkItemRequest = Message<"guardianai.v1.admin.CreateWorkItemRequest"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: string type = 3;
   */
  type: string;

  /**
   * @generated from field: string priority = 4;
   */
  priority: string;

  /**
   * @generated from field: string assignee_id = 5;
   */
  assigneeId: string;

  /**
   * @generated from field: string created_by = 6;
   */
  createdBy: string;

  /**
   * @generated from field: int64 due_date = 7;
   */
  dueDate: bigint;

  /**
   * @generated from field: map<string, string> metadata = 8;
   */
  metadata: { [key: string]: string };
};

/**
 * @generated from message guardianai.v1.admin.CreateWorkItemRequest
 */
export type CreateWorkItemRequestJson = {
  /**
   * @generated from field: string title = 1;
   */
  title?: string;

  /**
   * @generated from field: string description = 2;
   */
  description?: string;

  /**
   * @generated from field: string type = 3;
   */
  type?: string;

  /**
   * @generated from field: string priority = 4;
   */
  priority?: string;

  /**
   * @generated from field: string assignee_id = 5;
   */
  assigneeId?: string;

  /**
   * @generated from field: string created_by = 6;
   */
  createdBy?: string;

  /**
   * @generated from field: int64 due_date = 7;
   */
  dueDate?: string;

  /**
   * @generated from field: map<string, string> metadata = 8;
   */
  metadata?: { [key: string]: string };
};

/**
 * Describes the message guardianai.v1.admin.CreateWorkItemRequest.
 * Use `create(CreateWorkItemRequestSchema)` to create a new message.
 */
export const CreateWorkItemRequestSchema: GenMessage<CreateWorkItemRequest, {jsonType: CreateWorkItemRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 29);

/**
 * @generated from message guardianai.v1.admin.GetWorkItemRequest
 */
export type GetWorkItemRequest = Message<"guardianai.v1.admin.GetWorkItemRequest"> & {
  /**
   * @generated from field: string work_item_id = 1;
   */
  workItemId: string;
};

/**
 * @generated from message guardianai.v1.admin.GetWorkItemRequest
 */
export type GetWorkItemRequestJson = {
  /**
   * @generated from field: string work_item_id = 1;
   */
  workItemId?: string;
};

/**
 * Describes the message guardianai.v1.admin.GetWorkItemRequest.
 * Use `create(GetWorkItemRequestSchema)` to create a new message.
 */
export const GetWorkItemRequestSchema: GenMessage<GetWorkItemRequest, {jsonType: GetWorkItemRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 30);

/**
 * @generated from message guardianai.v1.admin.UpdateWorkItemRequest
 */
export type UpdateWorkItemRequest = Message<"guardianai.v1.admin.UpdateWorkItemRequest"> & {
  /**
   * @generated from field: string work_item_id = 1;
   */
  workItemId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: string priority = 5;
   */
  priority: string;

  /**
   * @generated from field: int64 due_date = 6;
   */
  dueDate: bigint;
};

/**
 * @generated from message guardianai.v1.admin.UpdateWorkItemRequest
 */
export type UpdateWorkItemRequestJson = {
  /**
   * @generated from field: string work_item_id = 1;
   */
  workItemId?: string;

  /**
   * @generated from field: string title = 2;
   */
  title?: string;

  /**
   * @generated from field: string description = 3;
   */
  description?: string;

  /**
   * @generated from field: string status = 4;
   */
  status?: string;

  /**
   * @generated from field: string priority = 5;
   */
  priority?: string;

  /**
   * @generated from field: int64 due_date = 6;
   */
  dueDate?: string;
};

/**
 * Describes the message guardianai.v1.admin.UpdateWorkItemRequest.
 * Use `create(UpdateWorkItemRequestSchema)` to create a new message.
 */
export const UpdateWorkItemRequestSchema: GenMessage<UpdateWorkItemRequest, {jsonType: UpdateWorkItemRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 31);

/**
 * @generated from message guardianai.v1.admin.ListWorkItemsRequest
 */
export type ListWorkItemsRequest = Message<"guardianai.v1.admin.ListWorkItemsRequest"> & {
  /**
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string status_filter = 3;
   */
  statusFilter: string;

  /**
   * @generated from field: string type_filter = 4;
   */
  typeFilter: string;

  /**
   * @generated from field: string assignee_filter = 5;
   */
  assigneeFilter: string;
};

/**
 * @generated from message guardianai.v1.admin.ListWorkItemsRequest
 */
export type ListWorkItemsRequestJson = {
  /**
   * @generated from field: int32 page = 1;
   */
  page?: number;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize?: number;

  /**
   * @generated from field: string status_filter = 3;
   */
  statusFilter?: string;

  /**
   * @generated from field: string type_filter = 4;
   */
  typeFilter?: string;

  /**
   * @generated from field: string assignee_filter = 5;
   */
  assigneeFilter?: string;
};

/**
 * Describes the message guardianai.v1.admin.ListWorkItemsRequest.
 * Use `create(ListWorkItemsRequestSchema)` to create a new message.
 */
export const ListWorkItemsRequestSchema: GenMessage<ListWorkItemsRequest, {jsonType: ListWorkItemsRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 32);

/**
 * @generated from message guardianai.v1.admin.ListWorkItemsResponse
 */
export type ListWorkItemsResponse = Message<"guardianai.v1.admin.ListWorkItemsResponse"> & {
  /**
   * @generated from field: repeated guardianai.v1.admin.WorkItemResponse items = 1;
   */
  items: WorkItemResponse[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * @generated from message guardianai.v1.admin.ListWorkItemsResponse
 */
export type ListWorkItemsResponseJson = {
  /**
   * @generated from field: repeated guardianai.v1.admin.WorkItemResponse items = 1;
   */
  items?: WorkItemResponseJson[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount?: number;
};

/**
 * Describes the message guardianai.v1.admin.ListWorkItemsResponse.
 * Use `create(ListWorkItemsResponseSchema)` to create a new message.
 */
export const ListWorkItemsResponseSchema: GenMessage<ListWorkItemsResponse, {jsonType: ListWorkItemsResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 33);

/**
 * @generated from message guardianai.v1.admin.AssignWorkItemRequest
 */
export type AssignWorkItemRequest = Message<"guardianai.v1.admin.AssignWorkItemRequest"> & {
  /**
   * @generated from field: string work_item_id = 1;
   */
  workItemId: string;

  /**
   * @generated from field: string assignee_id = 2;
   */
  assigneeId: string;

  /**
   * @generated from field: string assigned_by = 3;
   */
  assignedBy: string;
};

/**
 * @generated from message guardianai.v1.admin.AssignWorkItemRequest
 */
export type AssignWorkItemRequestJson = {
  /**
   * @generated from field: string work_item_id = 1;
   */
  workItemId?: string;

  /**
   * @generated from field: string assignee_id = 2;
   */
  assigneeId?: string;

  /**
   * @generated from field: string assigned_by = 3;
   */
  assignedBy?: string;
};

/**
 * Describes the message guardianai.v1.admin.AssignWorkItemRequest.
 * Use `create(AssignWorkItemRequestSchema)` to create a new message.
 */
export const AssignWorkItemRequestSchema: GenMessage<AssignWorkItemRequest, {jsonType: AssignWorkItemRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 34);

/**
 * @generated from message guardianai.v1.admin.ReassignWorkItemRequest
 */
export type ReassignWorkItemRequest = Message<"guardianai.v1.admin.ReassignWorkItemRequest"> & {
  /**
   * @generated from field: string work_item_id = 1;
   */
  workItemId: string;

  /**
   * @generated from field: string new_assignee_id = 2;
   */
  newAssigneeId: string;

  /**
   * @generated from field: string reassigned_by = 3;
   */
  reassignedBy: string;

  /**
   * @generated from field: string reason = 4;
   */
  reason: string;
};

/**
 * @generated from message guardianai.v1.admin.ReassignWorkItemRequest
 */
export type ReassignWorkItemRequestJson = {
  /**
   * @generated from field: string work_item_id = 1;
   */
  workItemId?: string;

  /**
   * @generated from field: string new_assignee_id = 2;
   */
  newAssigneeId?: string;

  /**
   * @generated from field: string reassigned_by = 3;
   */
  reassignedBy?: string;

  /**
   * @generated from field: string reason = 4;
   */
  reason?: string;
};

/**
 * Describes the message guardianai.v1.admin.ReassignWorkItemRequest.
 * Use `create(ReassignWorkItemRequestSchema)` to create a new message.
 */
export const ReassignWorkItemRequestSchema: GenMessage<ReassignWorkItemRequest, {jsonType: ReassignWorkItemRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 35);

/**
 * @generated from message guardianai.v1.admin.CompleteWorkItemRequest
 */
export type CompleteWorkItemRequest = Message<"guardianai.v1.admin.CompleteWorkItemRequest"> & {
  /**
   * @generated from field: string work_item_id = 1;
   */
  workItemId: string;

  /**
   * @generated from field: string completed_by = 2;
   */
  completedBy: string;

  /**
   * @generated from field: string resolution = 3;
   */
  resolution: string;
};

/**
 * @generated from message guardianai.v1.admin.CompleteWorkItemRequest
 */
export type CompleteWorkItemRequestJson = {
  /**
   * @generated from field: string work_item_id = 1;
   */
  workItemId?: string;

  /**
   * @generated from field: string completed_by = 2;
   */
  completedBy?: string;

  /**
   * @generated from field: string resolution = 3;
   */
  resolution?: string;
};

/**
 * Describes the message guardianai.v1.admin.CompleteWorkItemRequest.
 * Use `create(CompleteWorkItemRequestSchema)` to create a new message.
 */
export const CompleteWorkItemRequestSchema: GenMessage<CompleteWorkItemRequest, {jsonType: CompleteWorkItemRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 36);

/**
 * @generated from message guardianai.v1.admin.GetQueueRequest
 */
export type GetQueueRequest = Message<"guardianai.v1.admin.GetQueueRequest"> & {
  /**
   * @generated from field: string queue_name = 1;
   */
  queueName: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * @generated from message guardianai.v1.admin.GetQueueRequest
 */
export type GetQueueRequestJson = {
  /**
   * @generated from field: string queue_name = 1;
   */
  queueName?: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit?: number;
};

/**
 * Describes the message guardianai.v1.admin.GetQueueRequest.
 * Use `create(GetQueueRequestSchema)` to create a new message.
 */
export const GetQueueRequestSchema: GenMessage<GetQueueRequest, {jsonType: GetQueueRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 37);

/**
 * @generated from message guardianai.v1.admin.QueueResponse
 */
export type QueueResponse = Message<"guardianai.v1.admin.QueueResponse"> & {
  /**
   * @generated from field: string queue_name = 1;
   */
  queueName: string;

  /**
   * @generated from field: repeated guardianai.v1.admin.WorkItemResponse items = 2;
   */
  items: WorkItemResponse[];

  /**
   * @generated from field: int32 total_pending = 3;
   */
  totalPending: number;
};

/**
 * @generated from message guardianai.v1.admin.QueueResponse
 */
export type QueueResponseJson = {
  /**
   * @generated from field: string queue_name = 1;
   */
  queueName?: string;

  /**
   * @generated from field: repeated guardianai.v1.admin.WorkItemResponse items = 2;
   */
  items?: WorkItemResponseJson[];

  /**
   * @generated from field: int32 total_pending = 3;
   */
  totalPending?: number;
};

/**
 * Describes the message guardianai.v1.admin.QueueResponse.
 * Use `create(QueueResponseSchema)` to create a new message.
 */
export const QueueResponseSchema: GenMessage<QueueResponse, {jsonType: QueueResponseJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 38);

/**
 * @generated from message guardianai.v1.admin.PrioritizeRequest
 */
export type PrioritizeRequest = Message<"guardianai.v1.admin.PrioritizeRequest"> & {
  /**
   * @generated from field: string work_item_id = 1;
   */
  workItemId: string;

  /**
   * @generated from field: string priority = 2;
   */
  priority: string;

  /**
   * @generated from field: string prioritized_by = 3;
   */
  prioritizedBy: string;
};

/**
 * @generated from message guardianai.v1.admin.PrioritizeRequest
 */
export type PrioritizeRequestJson = {
  /**
   * @generated from field: string work_item_id = 1;
   */
  workItemId?: string;

  /**
   * @generated from field: string priority = 2;
   */
  priority?: string;

  /**
   * @generated from field: string prioritized_by = 3;
   */
  prioritizedBy?: string;
};

/**
 * Describes the message guardianai.v1.admin.PrioritizeRequest.
 * Use `create(PrioritizeRequestSchema)` to create a new message.
 */
export const PrioritizeRequestSchema: GenMessage<PrioritizeRequest, {jsonType: PrioritizeRequestJson}> = /*@__PURE__*/
  messageDesc(file_guardianai_v1_admin_admin, 39);

/**
 * @generated from service guardianai.v1.admin.AdminService
 */
export const AdminService: GenService<{
  /**
   * Dashboard & reporting
   *
   * @generated from rpc guardianai.v1.admin.AdminService.GetDashboard
   */
  getDashboard: {
    methodKind: "unary";
    input: typeof AdminDashboardRequestSchema;
    output: typeof AdminDashboardResponseSchema;
  },
  /**
   * Alias
   *
   * @generated from rpc guardianai.v1.admin.AdminService.GetAdminDashboard
   */
  getAdminDashboard: {
    methodKind: "unary";
    input: typeof AdminDashboardRequestSchema;
    output: typeof AdminDashboardResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdminService.GetSystemHealth
   */
  getSystemHealth: {
    methodKind: "unary";
    input: typeof SystemHealthRequestSchema;
    output: typeof SystemHealthResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdminService.GetPlatformStats
   */
  getPlatformStats: {
    methodKind: "unary";
    input: typeof PlatformStatsRequestSchema;
    output: typeof PlatformStatsResponseSchema;
  },
  /**
   * User management
   *
   * @generated from rpc guardianai.v1.admin.AdminService.ListUsers
   */
  listUsers: {
    methodKind: "unary";
    input: typeof ListUsersRequestSchema;
    output: typeof ListUsersResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdminService.GetUserDetails
   */
  getUserDetails: {
    methodKind: "unary";
    input: typeof GetUserDetailsRequestSchema;
    output: typeof UserDetailsResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdminService.SuspendUser
   */
  suspendUser: {
    methodKind: "unary";
    input: typeof SuspendUserRequestSchema;
    output: typeof SuspendUserResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdminService.RestoreUser
   */
  restoreUser: {
    methodKind: "unary";
    input: typeof RestoreUserRequestSchema;
    output: typeof RestoreUserResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdminService.UpdateUserRole
   */
  updateUserRole: {
    methodKind: "unary";
    input: typeof UpdateUserRoleRequestSchema;
    output: typeof UpdateUserRoleResponseSchema;
  },
  /**
   * Content moderation
   *
   * @generated from rpc guardianai.v1.admin.AdminService.ReviewContent
   */
  reviewContent: {
    methodKind: "unary";
    input: typeof ReviewContentRequestSchema;
    output: typeof ReviewContentResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdminService.ApproveContent
   */
  approveContent: {
    methodKind: "unary";
    input: typeof ApproveContentRequestSchema;
    output: typeof ApproveContentResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.AdminService.RejectContent
   */
  rejectContent: {
    methodKind: "unary";
    input: typeof RejectContentRequestSchema;
    output: typeof RejectContentResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_admin_admin, 0);

/**
 * @generated from service guardianai.v1.admin.WorkManagementService
 */
export const WorkManagementService: GenService<{
  /**
   * Work items
   *
   * @generated from rpc guardianai.v1.admin.WorkManagementService.CreateWorkItem
   */
  createWorkItem: {
    methodKind: "unary";
    input: typeof CreateWorkItemRequestSchema;
    output: typeof WorkItemResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.WorkManagementService.GetWorkItem
   */
  getWorkItem: {
    methodKind: "unary";
    input: typeof GetWorkItemRequestSchema;
    output: typeof WorkItemResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.WorkManagementService.UpdateWorkItem
   */
  updateWorkItem: {
    methodKind: "unary";
    input: typeof UpdateWorkItemRequestSchema;
    output: typeof WorkItemResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.WorkManagementService.ListWorkItems
   */
  listWorkItems: {
    methodKind: "unary";
    input: typeof ListWorkItemsRequestSchema;
    output: typeof ListWorkItemsResponseSchema;
  },
  /**
   * Assignments
   *
   * @generated from rpc guardianai.v1.admin.WorkManagementService.AssignWorkItem
   */
  assignWorkItem: {
    methodKind: "unary";
    input: typeof AssignWorkItemRequestSchema;
    output: typeof WorkItemResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.WorkManagementService.ReassignWorkItem
   */
  reassignWorkItem: {
    methodKind: "unary";
    input: typeof ReassignWorkItemRequestSchema;
    output: typeof WorkItemResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.WorkManagementService.CompleteWorkItem
   */
  completeWorkItem: {
    methodKind: "unary";
    input: typeof CompleteWorkItemRequestSchema;
    output: typeof WorkItemResponseSchema;
  },
  /**
   * Queue management
   *
   * @generated from rpc guardianai.v1.admin.WorkManagementService.GetWorkQueue
   */
  getWorkQueue: {
    methodKind: "unary";
    input: typeof GetQueueRequestSchema;
    output: typeof QueueResponseSchema;
  },
  /**
   * @generated from rpc guardianai.v1.admin.WorkManagementService.PrioritizeWorkItem
   */
  prioritizeWorkItem: {
    methodKind: "unary";
    input: typeof PrioritizeRequestSchema;
    output: typeof WorkItemResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_guardianai_v1_admin_admin, 1);

